// extracted by mini-css-extract-plugin
export default {"success":"f0iEb56c4ms3bAjModra9g==","successIcon":"vAXLQ5WQ0eZG5EEma-nzoA==","priceCta":"MnP1koWHNdG1l9xWFQk0cQ=="};